<template>
  <transition name="flash">
    <div v-if="flash" class="capture-flash"></div>
  </transition>
</template>

<script setup>
defineProps({
  flash: Boolean
})
</script>

<style scoped>
.capture-flash {
  position: absolute;
  inset: 0;
  background: white;
  z-index: 20;
  pointer-events: none;
}

.flash-enter-active {
  transition: opacity 0.05s;
}
.flash-leave-active {
  transition: opacity 0.3s ease-out;
}
.flash-enter-from {
  opacity: 0;
}
.flash-leave-to {
  opacity: 0;
}
</style>
